import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/world/press";

export default class Press extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Press")} | ${this.ucfirst("window-title")}`
    );
  }
}
